import { call } from "redux-saga/effects";
import { IAction } from "reduxsauce";
import { dependencies } from "../dependencies";

export function* printCurrentPage(_: IAction) {
  const { window } = dependencies;
  yield call([window, window.print]);
}
